import { string, object, number, ref } from 'yup';

export default object().shape({
    From:
        number()
            .required('REQUIRED')
            .min(100, 'BETWEEN_100_1000')
            .max(1000, 'BETWEEN_100_1000'),
    Qtty:
        number()
            .required('REQUIRED')
            .min(1, 'BETWEEN_1_100')
            .max(100, 'BETWEEN_1_100'),
    Random:
        number()
            .required('REQUIRED'),
    Password:
        string()
            .when('Random', {
                is: 0,
                then:
                    string()
                        .required('REQUIRED')
                        .matches(/^(?=.*[A-Z])(?=.*[!#$&*@])(?=.*\d)(?=.*[a-z]).{8,20}/, 'VALID_PASSWORD')
            }),
    RepeatedPassword:
        string()
            .when('Random', {
                is: 0,
                then:
                    string()
                        .required('REQUIRED')
                        .oneOf([ref('Password')], 'MATCH_PASSWORD')
            })
});
